var _style, _g, _path, _g2, _g3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/2000/svg",
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#F7F7F7;}\n\t.st2{fill:#0E538C;}\n\t.st3{fill:#E2E2E2;}\n\t.st4{fill:#DCF2FF;}\n\t.st5{fill:#B6E7FF;}\n\t.st6{fill:#541554;}\n\t.st7{fill:#2A94F4;}\n\t.st8{fill:#FCD2B1;}\n\t.st9{fill:#FFE3CA;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{opacity:0.59;fill:#541554;}\n\t.st12{fill:#80D5FF;}\n\t.st13{fill:#CCE9FF;}\n\t.st14{fill:#85DDFF;}\n\t.st15{opacity:0.26;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1002,668c-9.8,0-18.9,3-26.6,8.1c-1.7-26.3-23.6-47.1-50.4-47.1c-8.5,0-16.5,2.1-23.5,5.8c0-0.4,0-0.9,0-1.3    c0-53.8-43.7-97.5-97.5-97.5c-26.5,0-50.4,10.5-68,27.6c-2.4-11.5-13.2-19.9-25.7-18.5c-11.2,1.2-20.1,10.6-20.8,21.8    c-0.9,13.7,10,25,23.5,25c1,0,1.9-0.1,2.8-0.2c-6,12.6-9.3,26.8-9.3,41.7c0,0.4,0,0.8,0,1.2l-169-42.6V592l-0.2,0.1L537,592v0.1    l-169,42.6c0-0.4,0-0.8,0-1.2c0-14.9-3.4-29-9.3-41.7c0.9,0.1,1.9,0.2,2.8,0.2c13.5,0,24.3-11.3,23.5-25    c-0.7-11.3-9.6-20.6-20.8-21.8c-12.5-1.4-23.2,7-25.7,18.5c-17.6-17.1-41.6-27.6-68-27.6c-53.8,0-97.5,43.7-97.5,97.5    c0,0.4,0,0.9,0,1.3c-7-3.7-15-5.8-23.5-5.8c-26.8,0-48.6,20.8-50.4,47.1c-7.7-5.1-16.9-8.1-26.6-8.1C44.6,668,22,692.2,22,722v2.2    C22,814.1,94.9,887,184.8,887H537h0.5h366.6c82,0,148.4-66.4,148.4-148.4V722C1052.5,692.2,1029.9,668,1002,668z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.9,315l-13,0v0l-0.5,0l-0.5,0v0l-13,0c-11,71-135,317-324,317c45.4,0,318.5,0,337,0c0.7,0,1,0,1,0   c18.5,0,291.6,0,337,0C685.9,632,561.9,386,550.9,315z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st1",
    d: "M1049.6,953.3H30.4c-5.7,0-10.4-4.7-10.4-10.4v-61.5c0-5.7,4.7-10.4,10.4-10.4h1019.2c5.7,0,10.4,4.7,10.4,10.4  v61.5C1060,948.7,1055.3,953.3,1049.6,953.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M573.8,538.5c0.8-9.5,3.2-22.2,0-30.1c-3.2-7.9-9.5-13.5-15.9-15.9c-6.3-2.4-15.1-7.1-23-6.3   c-7.9,0.8-19.8,8.7-23.8,12.7s-9.5,18.2-9.5,23.8c0,5.5,4.8,12.7,6.3,17.4s0,16.6,10.3,21.4c10.3,4.8,11.9,8.7,25.4,5.5   c13.5-3.2,26.2-10.3,27-13.5S573.8,538.5,573.8,538.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540,556.2L540,556.2c41.5,0,75.5,34,75.5,75.5v125.4c0,5.2-4.3,9.5-9.5,9.5H474c-5.2,0-9.5-4.3-9.5-9.5V631.7   C464.5,590.1,498.5,556.2,540,556.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 707.7,
    className: "st4",
    width: 496,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 721.7,
    className: "st5",
    width: 424.7,
    height: 194.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M625.4,663.7l-12.1-64.2c-2.5-18.6-64.9-34.1-64.9-34.1c-4.8,0-12.8,0-17.6,0c0,0-62.7,16.6-65.2,35.2   L450,664.5c-3.9,29,20.2,26.9,46.2,35.4l34.7,11.4c4.8,0,12.8,0,17.6,0l34.7-11.4C609.1,691.4,629.4,692.7,625.4,663.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M609.4,614.6l0,0.5l-2.3,98c-1.2,1-2.8,1.6-4.5,1.6H475.2c-0.4,0-0.8,0-1.1-0.1l-2.6-100H609.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "521.9,553.8 527.2,580.3 540.3,603.2 551.2,580.3 555.5,553.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M570,528.5c0,28.8-5,40.1-23,46.7c-4.6,1.7-9.5,1.5-14.2,0.1c-17.7-5.2-22.8-18.3-22.8-46.8   c0-18.3,10.7-24.2,27.3-24.2S570,510.2,570,528.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9947 -0.1025 0.1025 0.9947 -52.6199 55.1787)",
    className: "st9",
    cx: 510.7,
    cy: 539.7,
    rx: 6,
    ry: 10.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1025 -0.9947 0.9947 0.1025 -25.1256 1051.6052)",
    className: "st9",
    cx: 570.2,
    cy: 539.7,
    rx: 10.7,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M613.3,621.4l-3.6,86.2c0,2.2-1,4.2-2.6,5.5c-1.2,1-2.8,1.6-4.5,1.6H475.2c-0.4,0-0.8,0-1.1-0.1   c-3.4-0.5-6-3.5-6-7l-3.6-86.2c0-3.9,3.2-7.1,7.1-7.1h134.6c0.6,0,1.2,0.1,1.8,0.2c0.5,0.1,1,0.3,1.4,0.5   C611.7,616.3,613.3,618.7,613.3,621.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 538.7,
    cy: 664.5,
    r: 13.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M391.8,711.3H382c-5,0-9.1-4.1-9.1-9.1v-29.3h28v29.3C400.9,707.2,396.8,711.3,391.8,711.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M388,669.5c-0.5,0-0.9-0.2-1.3-0.4c-0.4-0.3-0.7-0.7-1-1.1c-0.5-0.8-0.8-1.8-0.8-2.9c0-1.1,0.6-2.3,1.3-3    c0.7-0.8,1.3-1.3,1.6-1.7c0.4-0.4,0.5-0.6,0.7-1.1c0.1-0.4,0.2-1,0.2-1.6c0-1.2-0.5-2.7-0.9-4.4c0.8,0.3,1.6,0.8,2.3,1.4    c0.7,0.6,1.3,1.4,1.6,2.3c0.4,0.9,0.6,1.9,0.5,3c0,0.6-0.2,1.1-0.5,1.7c-0.3,0.5-0.6,1-1,1.4c-0.7,0.8-1.4,1.2-1.8,1.6    c-0.4,0.4-0.7,0.6-0.9,1c-0.2,0.4-0.4,1.1-0.4,1.7C387.5,668.1,387.5,668.8,388,669.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M397.6,695.9v-2.4c3.6,0,6.1-1.1,7.1-3.2c0.8-1.6,0.6-3.5-0.6-5c-1.4-1.8-3.7-2.6-6.3-2.1l-0.4-2.3     c3.5-0.6,6.8,0.5,8.7,3c1.7,2.2,2,5.1,0.8,7.5C406,693.1,403.7,695.9,397.6,695.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "680.1,667.6 674.4,668.7 668.8,638 670.6,631.7 674.5,637   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "698.9,674.1 693.3,672.7 700.7,642.5 705,637.4 706.4,643.9   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "696.6,670.7 690.8,670 694.4,639 698,633.5 700.2,639.7   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "705.4,651.1 705,661.3 704,685.1 703,711.3 670.3,711.3 669,685.1 667.7,661.3 667.2,651.1   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "705,661.3 704,685.1 669,685.1 667.7,661.3   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M507.1,524.2c-1.9-1.3,0.2-6.6-0.3-9c-0.6-2.6,0.8-5.2,2.4-7.2c5-5.8,12.4-8.1,19.6-8.6    c7.2-0.5,14.4,0.4,21.5-0.3c7.2-0.7,14.6-3.4,19.2-9.6c0.4-0.5,3-0.6,3.6,0.2c2.2,3,4.4,6.1,5.8,9.7s1.7,7.8,0.2,11.4    c-2,4.6-7.9,8-12.2,9.6C566.9,520.2,527.5,537.7,507.1,524.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "560.3,517.9 569,536.1 573.8,514.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M516.7,521.8c-1.6,1.6-4,18.2-4,18.2l-6.4-19.5L516.7,521.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.9,
    y: 722,
    className: "st12",
    width: 424.3,
    height: 6.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "502.6,256.3 476.7,289.6 517.9,342.9 518,305.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "572.2,256.4 598,289.7 556.7,343 556.7,305.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "552,299.7 550.5,315 523.8,315 522.7,299.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M537.6,50c0,0,32.8,47.1,43.7,101.2c0.2,1,0.4,2,0.6,3c0.2,1,0.4,2,0.5,3c1.5,8.9,2.4,18,2.4,27.1   c0,43.7-13.6,93-27.4,121.5l-39.4,0c-13.8-28.6-27.9-77.9-27.9-121.6c0-9,0.9-18.1,2.4-27.1c0.2-1,0.4-2,0.5-3c0.2-1,0.4-2,0.6-3   C504.7,97.1,537.6,50,537.6,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M537.6,50c0,0,32.8,47.1,43.7,101.2c0.2,1,0.4,2,0.6,3c-13.6,9.5-29,14.6-44.4,14.5    c-15.4,0-30.7-5.1-44.4-14.6c0.2-1,0.4-2,0.6-3C504.7,97.1,537.6,50,537.6,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M493.7,151.1c-0.2,1-0.4,2-0.6,3c-0.2,1-0.4,2-0.5,3c6.4,4.4,13.2,7.8,20.2,10.2c8,2.8,16.4,4.2,24.7,4.2    c8.4,0,16.7-1.4,24.7-4.1c7-2.4,13.8-5.8,20.2-10.2c-0.2-1-0.3-2-0.5-3c-0.2-1-0.4-2-0.6-3c-13.1,9.4-28,14.8-43.8,14.8    C521.7,165.9,506.8,160.6,493.7,151.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M499.7,140.1c4.2-15.7,26.6-66.9,34.6-78.1c-3.1,10.5-29.4,73.2-25.2,78.1   C503.6,140.8,499.7,140.1,499.7,140.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "542.6,256.4 542.5,325.8 537.3,342.9 532.1,325.8 532.2,256.4  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 1008,
    cy: 589,
    r: 36
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 906.5,
    cy: 564.5,
    r: 8.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 935.5,
    cy: 500.5,
    r: 20.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 100.5,
    cy: 538.5,
    r: 34.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 173.5,
    cy: 564.5,
    r: 8.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 176.5,
    cy: 465.5,
    r: 20.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M896.7,898.5c-16.3,0-23.2-13.1-26-26.9c-3.1-15.6-0.8-32.3-0.8-32.3h53.6c0,0,0.1,0.6,0.2,1.8   C924.6,851,927.9,898.5,896.7,898.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M923.5,839.4c0,1.2-12,2.1-26.8,2.1c-14.8,0-26.8-0.9-26.8-2.1c0-1.2,12-2.1,26.8-2.1   C911.5,837.3,923.5,838.2,923.5,839.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M830,690.9c0,0,28.2,43,45.2,69.2c16.9,26.2,21.4,31.7,23.4,40.2c2,8.5,3.8,39.7,3.8,39.7h2.2   c0,0,1.4-26.4-1.2-35.1c-2.6-8.7-1.6-12.1-0.4-21.2c1.2-9.1,2.8-23.6-6.4-33.7c-9.2-10.1-6.8-20-10-26.6   c-3.2-6.7-28.2-14.7-31.5-21.6C852,694.9,837.9,690.7,830,690.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M830,690.9c0,0,8.9,10.1,14.9,13.5c6.1,3.4,8.9,0.4,13.5,8.7c4.6,8.3,4.8,11.9,9.1,16.1   c4.2,4.2,9.3,4.4,9.7,13.7c0.4,9.3-2,17.2-2,17.2S831.8,693.1,830,690.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M895.8,840h-2c0,0-0.6-13.7-6.1-20.4c-3.5-4.3-18.4-9.2-33.2-15c-8.1-3.2-16.2-6.7-22.3-10.6   c-17.2-10.9-33.5-46-34.9-52.3c-0.5-2.2-0.7-3.5-0.7-4.4v0c0-1.7,0.9-1.9,2.3-3.6c0.7-0.8,2.8-0.5,5.3,0.2   c7.4,2.3,13.6,7.3,17.5,14c3.6,6.2,9.3,13.9,16.3,15.8c12.1,3.2,11.1,5.2,15.6,17.6c4.5,12.3,15.7,14.3,29.8,28.8   C897.6,824.7,895.8,840,895.8,840z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M854.5,804.6c-8.1-3.2-16.2-6.7-22.3-10.6c-17.2-10.9-33.5-46-34.9-52.3c-0.5-2.2-0.7-3.5-0.7-4.4   c0,0.4,0.8,6,9.8,9.7c9.3,3.8,11.1,3.8,12.3,9.7c1.2,5.8,2.2,12.1,7.1,13.3c4.8,1.2,7.9-4.2,11.7,4.6c3.8,8.9,5.7,11.9,9.2,13.1   c3.5,1.2,6.2-0.6,7,6.3C854.1,798.2,854.4,802.1,854.5,804.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M896.7,898.5c-16.3,0-23.2-13.1-26-26.9c16-6.1,36.2-15.8,52.9-30.5C924.6,851,927.9,898.5,896.7,898.5z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.1,898.5c19.6,0,27.9-15.7,31.1-32.3c3.7-18.7,1-38.7,1-38.7h-64.2c0,0-0.1,0.8-0.2,2.1   C161.5,841.5,157.6,898.5,195.1,898.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M162.9,827.6c0,1.4,14.4,2.5,32.1,2.5c17.7,0,32.1-1.1,32.1-2.5c0-1.4-14.4-2.5-32.1-2.5   C177.3,825.1,162.9,826.2,162.9,827.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.1,649.6c0,0,33.9,51.5,54.2,83s25.6,38,28.1,48.1c2.4,10.2,4.6,47.7,4.6,47.7h1.5c0,0-0.5-31.8-2.4-42.5   c-1.8-10.4,0.1-14.1,1.6-25c1.5-10.9,3.4-28.3-7.6-40.4c-11-12.1-8.1-23.9-12-31.9c-3.9-8-33.9-17.7-37.7-25.9   C134.5,654.4,117.5,649.3,108.1,649.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.1,649.6c0,0,10.6,12.1,17.9,16.2c7.3,4.1,10.6,0.5,16.2,10.4c5.6,9.9,5.8,14.3,10.9,19.4   c5.1,5.1,11.1,5.3,11.6,16.4c0.5,11.1-2.4,20.6-2.4,20.6S110.3,652.2,108.1,649.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.3,828.3h-1.5c0,0-0.5-10.3-4.5-15.3c-2.6-3.2-13.8-6.9-24.9-11.3c-6.1-2.4-12.2-5.1-16.7-8   c-12.9-8.2-25.2-34.6-26.2-39.3c-0.4-1.6-0.5-2.6-0.5-3.3v0c0-1.3,0.7-1.5,1.7-2.7c0.5-0.6,2.1-0.4,4,0.2   c5.6,1.7,10.2,5.5,13.1,10.5c2.7,4.7,7,10.5,12.2,11.9c9.1,2.4,8.3,3.9,11.7,13.2c3.3,9.2,11.8,10.8,22.4,21.7   C193.6,816.8,192.3,828.3,192.3,828.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M161.3,801.8c-6.1-2.4-12.2-5.1-16.7-8c-12.9-8.2-25.2-34.6-26.2-39.3c-0.4-1.6-0.5-2.6-0.5-3.3   c0,0.3,0.6,4.5,7.3,7.3c7,2.9,8.3,2.9,9.2,7.3c0.9,4.4,1.7,9.1,5.3,10c3.6,0.9,5.9-3.2,8.8,3.5c2.9,6.7,4.3,8.9,6.9,9.8   c2.6,0.9,4.7-0.5,5.2,4.7C161,796.9,161.2,799.9,161.3,801.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M203.4,828.3h1.8c0,0,3.5-63.8,8.4-69.7c3.1-3.8,13.4-10.7,26.6-15.9c7.2-2.9,14.4-6,19.8-9.4   c15.3-9.7,29.8-40.9,31-46.5c0.4-1.9,0.6-3.1,0.6-3.9v0c0-1.5-0.8-1.7-2.1-3.2c-0.6-0.7-2.5-0.5-4.7,0.2c-6.6,2-12.1,6.5-15.6,12.5   c-3.2,5.5-8.3,12.4-14.5,14.1c-10.8,2.9-9.9,4.7-13.8,15.6c-4,11-14,12.7-26.5,25.7C201.8,760.6,203.4,828.3,203.4,828.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M240.1,742.8c7.2-2.9,14.4-6,19.8-9.4c15.3-9.7,29.8-40.9,31-46.5c0.4-1.9,0.6-3.1,0.6-3.9   c0,0.4-0.8,5.3-8.7,8.6c-8.2,3.4-9.9,3.4-10.9,8.6c-1.1,5.2-2,10.8-6.3,11.8c-4.3,1.1-7-3.8-10.4,4.1c-3.4,7.9-5,10.6-8.2,11.7   c-3.1,1.1-5.5-0.5-6.2,5.6C240.5,737,240.2,740.6,240.1,742.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M195.1,898.5c19.6,0,27.9-15.7,31.1-32.3c-19.2-7.3-43.4-19-63.5-36.6C161.5,841.5,157.6,898.5,195.1,898.5z    "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup);
export default __webpack_public_path__ + "static/media/startup.fdc281165990f3eeb2d6fd60d3bea8fb.svg";
export { ForwardRef as ReactComponent };